'use strict';

var URI = require('urijs');
var _ = require('lodash');
var FetchUrlFactory = function FetchUrlFactory() {
  var FILTER = 'filter';
  var FetchUrl = function FetchUrl(config) {
    this.url = config.url;
    this.params = config.params;
  };
  function createUrl(url) {
    return new URI(url);
  }
  function appendBrackets(text) {
    return '(' + text + ')';
  }
  function mergeFilterParameters(existingFilter, filter) {
    return appendBrackets(existingFilter) + ';' + appendBrackets(filter);
  }
  function appendParameters(url, params) {
    var existingParams = url.query(true);
    _.forEach(params, function (value, key) {
      if (!_.isUndefined(value)) {
        if (key === FILTER && existingParams[FILTER]) {
          value = mergeFilterParameters(existingParams[FILTER], value);
          url.removeSearch(FILTER);
        }
        url.addQuery(key, value);
      }
    });
  }
  FetchUrl.prototype.toString = function () {
    var url = createUrl(this.url);
    appendParameters(url, this.params);
    return url.toString();
  };
  FetchUrl.prototype.getUrlWithQueryAsString = function (exclude) {
    var url = createUrl(this.url);
    appendParameters(url, _.omit(this.params, exclude));
    return url.toString();
  };
  FetchUrl.prototype.getUrlAsString = function () {
    return createUrl(this.url).toString();
  };
  FetchUrl.prototype.getQueryAsString = function () {
    var url = createUrl(this.url);
    appendParameters(url, this.params);
    return url.query();
  };
  FetchUrl.prototype.getAllParams = function () {
    var url = createUrl(this.url);
    appendParameters(url, this.params);
    return url.query(true);
  };
  return FetchUrl;
};
FetchUrlFactory.$inject = [];
module.exports = FetchUrlFactory;